/* eslint-disable no-console */
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { initializeApp, getApps } from 'firebase/app';
import {
  collection,
  connectFirestoreEmulator,
  getFirestore,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
// Initialize Firebase app (only if not already initialized)
const firebaseConfig = {
  apiKey: 'AIzaSyCgtSDpkH743PcdB0b2u4Uu0XblSvJR49o',
  authDomain: 'carsnus-1262c.firebaseapp.com',
  projectId: 'carsnus-1262c',
  storageBucket: 'carsnus-1262c.appspot.com',
  messagingSenderId: '1009521238443',
  appId: '1:1009521238443:web:8d644c2f02609a77bbf2ee',
  measurementId: 'G-SPBW3ZGJV5',
};

// Use existing app if available, otherwise initialize
const firebase =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(firebase);
export const storage = getStorage(firebase);
export const firestore = getFirestore(firebase);
export const functions = getFunctions(firebase);

// Lazy load messaging - only initialize when needed
// This reduces initial bundle size significantly
let messagingInstance = null;

export const getMessagingInstance = async () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!messagingInstance) {
    // Dynamic import to reduce initial bundle size
    const { getMessaging } = await import('firebase/messaging');
    messagingInstance = getMessaging(firebase);
  }

  return messagingInstance;
};

export const userCollectionRef = collection(firestore, 'users');
export const postCollectionRef = collection(firestore, 'posts');
export const storiesCollectionRef = collection(firestore, 'stories');
export const conversationCollectionRef = collection(firestore, 'conversations');
export const notificationsCollectionRef = collection(
  firestore,
  'notifications',
);
export const savedAlertsCollectionRef = collection(firestore, 'savedAlerts');
export const paymentLogCollectionRef = collection(firestore, 'paymentLog');
// connectAuthEmulator(auth, 'http://127.0.0.1:9099');
// connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
// connectFunctionsEmulator(functions, '127.0.0.1', 5001);
// if (process.env.NODE_ENV === 'development') {
//   connectAuthEmulator(auth, 'http://127.0.0.1:9099');
//   connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
//   connectFunctionsEmulator(functions, '127.0.0.1', 5001);
// }
